import { useQuery } from '@tanstack/react-query';
import { getWikiFromClient, GetWikiFromClientOptions } from '../api/wikis';
import { WikiNamespaces } from '~/monolith-api';

export function getWikiKey(namespace: WikiNamespaces, identifier: string | number | null) {
   return ['get-wiki', namespace, identifier];
}

export function useWiki(
   namespace: WikiNamespaces,
   identifier: string | number | null,
   options: GetWikiFromClientOptions = {}
) {
   const queryFunction = async () => {
      if (!identifier) {
         return;
      }
      return await getWikiFromClient(namespace, identifier, options);
   };

   return useQuery({
      queryFn: queryFunction,
      queryKey: getWikiKey(namespace, identifier),
   });
}
